import PropTypes from 'prop-types'
import React, { Component } from "react"
import ReactDrawer from 'react-drawer';
import 'react-drawer/lib/react-drawer.css';

import { connect } from "react-redux"


import { Link } from "react-router-dom"


// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown"
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import FollowDropdown from "../CommonForBoth/TopbarDropdown/MessageDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import RightSidebar from '../CommonForBoth/RightSidebar'



import logo from "../../assets/images/realtyspace-logo.png"
import logoLightSvg from "../../assets/images/small-logo.png"
import noLogo from "../../assets/images/no-logo.png"
import { getUserDetail } from "store/actions";
//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import { toggleRightSidebar, showRightSidebar, hideRightSidebar } from "../../store/actions"
import ReminderDropdown from 'components/CommonForBoth/TopbarDropdown/ReminderDropdown';
import TwilioText from 'components/CommonForBoth/TopbarDropdown/TwilioText';
import Cookies from "js-cookie"
class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isSearch: false,
      open: false,
      position: 'right',
    }
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleRightDrawer = this.toggleRightDrawer.bind(this);
    this.toggleFullscreen = this.toggleFullscreen.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.onDrawerClose = this.onDrawerClose.bind(this);
  }
  /**
   * Toggle sidebar
   */
  toggleMenu() {
   // if (this.props.disableMenuToggle) return
    this.props.toggleMenuCallback()
  }
  /** 
   * Right sidebar drawer 
  * */

  toggleRightDrawer() {
    this.setState({ position: 'right' });
    this.setState({ open: !this.state.open });
  }
  closeDrawer() {
    this.setState({ open: false });
  }
  onDrawerClose() {
    this.setState({ open: false });
  }


  /**
   * Toggles the sidebar
   */
  toggleRightbar() {
    
    this.props.toggleRightSidebar();
  }

  toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }
  componentDidMount() {
    // const { onGetUserDetail } = this.props;
    //   onGetUserDetail(localStorage.getItem('userId'));
  }
  render() {
    const { userdetail } = this.props;
    return (
      <React.Fragment>
        <header id="page-topbar">
          <div className="navbar-header">

            <div className="d-flex">
              <div className="navbar-brand-box d-lg-none d-md-block">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logo} alt="" height="22" />
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logoLightSvg} alt="" height="22" />
                  </span>
                </Link>
              </div>

              <button
                type="button"
                onClick={this.toggleMenu}
                className="btn btn-sm px-3 font-size-16 header-item"
                id="vertical-menu-btn"
               // disabled={this.props.disableMenuToggle}
              >
                <i className="fa fa-fw fa-bars"></i>
              </button>
              <Link to="/" className="d-none d-lg-block">
              {userdetail?.logoFilePath ? 
              <img className="site-logo" style={{height:68, paddingTop:10}} src={userdetail?.logoFilePath}/>
              : <img className="site-logo" style={{height:68}} src={noLogo} /> }
              </Link>

             
              
            </div>
            <div className="d-flex">
              <div className="dropdown d-inline-block d-lg-none ms-2">
                <button
                  
                  type="button"
                  className="btn header-item noti-icon"
                  id="page-header-search-dropdown"
                >
                 
                </button>
              
              </div>
               {userdetail?.agentTimeZone?.isTwilioIntegrationEnabled && (   
              <TwilioText userdetail={userdetail} />
               )}
          {/* <LanguageDropdown /> */}
             <NotificationDropdown />
              <ReminderDropdown />
			  {/* <FollowDropdown /> */}
              <ProfileMenu userdetail={userdetail} />
{/* 
              <div className="dropdown d-inline-block">
                  <Link to="/setting/general/currency"> 
                   <button
                 
                  type="button"
                  className="btn header-item noti-icon right-bar-toggle"
                >
                  <i className="bx bx-cog"></i>
                  </button>
                  </Link>
               
              </div> */}
            </div>
          </div>
        </header>
        <ReactDrawer
          open={this.state.open}
          position={this.state.position}
          onClose={this.onDrawerClose}
        >
          <RightSidebar onClose={this.onDrawerClose} />
        </ReactDrawer>
      </React.Fragment>
    )
  }
}
Header.propTypes = {
  t: PropTypes.any,
  toggleMenuCallback: PropTypes.any,
  disableMenuToggle: PropTypes.bool,
  toggleRightSidebar: PropTypes.func,
  //onGetUserDetail: PropTypes.func,
  userdetail: PropTypes.object,
  layoutType: PropTypes.string,
};

const mapStateToProps = state => ({
  //userdetail: state.Login.userdetail,
  layoutType: state.Layout.layoutType,
});

const mapDispatchToProps = dispatch => ({
  toggleRightSidebar: () => dispatch(toggleRightSidebar()),
  //onGetUserDetail: (id) => dispatch(getUserDetail(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Header));


